/* cx-show-cart.js
   Backstop for visitors who land on /cart directly (bookmarks, old links): the /cart
   redirect in theme.liquid bounces them back with ?show-cart=true, and this opens
   Dawn's native <cart-drawer>. Header-icon clicks never reach /cart — the inline
   capture handler in theme.liquid intercepts those from first paint. */
(function () {
  function getShowCartFlag() {
    try {
      return (new URLSearchParams(window.location.search).get("show-cart") || "").toLowerCase();
    } catch (e) {
      return "";
    }
  }

  function cleanUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("show-cart");
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  function openCartDrawer() {
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return true;
    }
    return false;
  }

  function run() {
    if (getShowCartFlag() !== "true") return;

    // cart-drawer.js is deferred, so the custom element may not be defined yet on a
    // cold load — poll briefly until it is (normally ready well under a second).
    var tries = 0;
    var maxTries = 50; // 5 seconds
    var timer = setInterval(function () {
      tries++;

      if (openCartDrawer() || tries >= maxTries) {
        cleanUrl();
        clearInterval(timer);
      }
    }, 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
